<template>
  <el-dialog title='详情' :visible.sync='dialogVisible' width='650px' center
             @close='dialogClose'>
    <div class='detail' v-loading='dialogLoading'>
      <div class='baseInfo'>
        <div class='baseInfoTitle'>
          <div class='line' />
          <span>基础信息</span>
          <p>{{ detailData.isEnable|isEnableFormat }}</p>
        </div>
        <div class='baseInfoContent'>
          <div class='baseInfoContentItem'>
            <span class='span1'>用户姓名：</span>
            <span>{{ detailData.empNm }}</span>
          </div>
          <div class='baseInfoContentItem specialItem'>
            <div class='specialOne'>
              <span class='span1'>手机号：</span>
              <span>{{ detailData.account }}</span>
            </div>
            <div>
              <span class='span1'>邮箱：</span>
              <span>{{ detailData.email }}</span>
            </div>
          </div>
          <div class='baseInfoContentItem specialItem'>
            <div class='specialOne'>
              <span class='span1'>性别：</span>
              <span>{{ detailData.empGender |sexFormat }}</span>
            </div>
            <div>
              <span class='span1'>年龄：</span>
              <span>{{ detailData.age }}</span>
            </div>
          </div>
          <div class='baseInfoContentItem'>
            <span class='span1'>服务港口：</span>
            <span>{{ detailData.port }}</span>
          </div>
          <div class='baseInfoContentItem'>
            <span class='span1'>所属公司：</span>
            <span>{{ detailData.fullName }}</span>
          </div>
          <div class='baseInfoContentItem'>
            <span class='span1'>PC所属角色：</span>
            <span>{{ detailData.roleNm }}</span>
          </div>
          <div class='baseInfoContentItem'>
            <span class='span1'>APP所属角色：</span>
            <span>{{ detailData.appRoleName }}</span>
          </div>
          <div class='baseInfoContentItem'>
            <span class='span1'>所属部门：</span>
            <span>{{ detailData.depNm }}</span>
          </div>
          <div class='baseInfoContentItem'>
            <span class='span1'>创建时间：</span>
            <span>{{ detailData.createTime }}</span>
          </div>
        </div>
      </div>
      <div class='operation'>
        <div class='operationTitle'>
          <div class='line' />
          <span>操作信息</span>
        </div>
        <div class='operationTable'>
          <el-table :data='detailData.operateRecordList' border>
            <el-table-column label='操作时间' prop='createTime' width='160px' align='center' />
            <el-table-column label='操作类型' prop='operateType' align='center' />
            <el-table-column label='操作人' prop='operationName' align='center' />
            <el-table-column label='备注' prop='remark' align='center' />
          </el-table>
        </div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
  import { qryEmployeeDetail } from '@/service/basicfile';

  export default {
    name: 'user-info',
    data() {
      return {
        dialogVisible: false,
        dialogLoading: false,
        detailData: {},
      };
    },
    filters: {
      isEnableFormat(val) {
        switch (val) {
          case '0':
            return '禁用中';
          case '1':
            return '启用中';
          case '2':
            return '审核中';
        }
      },
      sexFormat(sex) {
        switch (sex) {
          case '0':
            return '--';
          case '1':
            return '男';
          case '2':
            return '女';
        }
      },
    },
    methods: {
      statusFormat(val) {
        switch (val) {
          case 1:
            return '启用中';
          case 0:
            return '禁用中';
        }
      },
      async dialogOpen(id) {
        this.detailData = {};
        this.dialogVisible = true;
        this.dialogLoading = true;
        const res = await qryEmployeeDetail(id);
        this.dialogLoading = false;
        if (res.status !== 0) return this.$message.warning(res.message);
        this.detailData = res.data;
        const ports = [];
        if (res.data.employeePorts) {
          for (const item of res.data.employeePorts) {
            ports.push(item.portName);
          }
          this.detailData.port = ports.toString();
        }
      },
      dialogClose() {
        this.dialogVisible = false;
      },
    },
  };
</script>

<style scoped></style>
